import { useEffect, useRef, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import FormButton from "../../Components/Buttons/FormButton";
import FormFileUpload from "../../Components/FormTag/FormFileUpload";
import InputFiled from "../../Components/FormTag/InputFiled";
import { ClientData } from "../Client/model/Client.type";

import FormSelect from "../../Components/FormTag/FormSelect";
import { attachments, ItemsBasicInfoData } from "./model/items.model";
import { convertFileToBase64, formSelectOptionList } from "../../Utility/Utility";
import DragAndDropButton from "../../Components/Buttons/DragAndDropButton";
import { TiDelete } from "react-icons/ti";
interface ItemsBasicInfoProps {
  handelAllTabData?: (data: ClientData) => void;
  clientData?: ClientData;
  handleNext: () => void;
  lookupData?: any;
  onSubmit: (data: any) => void;
  initialData?: ItemsBasicInfoData;
}
export default function ItemsBasicInfo(props: ItemsBasicInfoProps) {
  console.log("lookup Data basics", props.lookupData);
  const navigation = useNavigate();
  const [imageName, setImageName] = useState("There is no image added");
  const [photoImg, setPhotoImg] = useState();
  const { handelAllTabData, clientData, handleNext, onSubmit, initialData } =
    props;
  const inputFile = useRef<HTMLInputElement | null>(null);
  const [dataForLogo, setDataForLogo] = useState<File[]>([]);
  const [attachmentFiles, setAttachmentFiles] = useState<any[]>([]);

  const {
    handleSubmit,
    register,
    reset,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useForm<ItemsBasicInfoData>({
    defaultValues: initialData || ItemsBasicInfoData,
  });
  useEffect(() => {
    if (initialData) {
      reset(initialData);
    }
  }, [initialData])
  
  const nextData: SubmitHandler<ItemsBasicInfoData> = async (data) => {
    if(data.item_category){
      data.item_category={
        code:data.item_category
      }
    }
    if (data.item_group) {
      data.item_group = {
        code: data.item_group,
      };
    }
    const logoObject = await finalAttachment(dataForLogo);
    if ((logoObject).length > 0) {
      data.logo = logoObject[0];
    }else{
      data.logo = null;
    }
    props.onSubmit(data);
    reset(data);
    handleNext();
  };
  const handelCancelBtn = () => {
    navigation("/account/client/items");
  };

  const handleDeleteFileForLogo = (index: number) => {
    const newData = [...dataForLogo];
    newData.splice(index, 1);
    setDataForLogo(newData);
  };
  const finalAttachment = async (dataN: File[]): Promise<attachments[]> => {
    const attachmentsArray = await Promise.all(
      dataN?.map(async (file, index) => {
        const existingAttachment = attachmentFiles[index];
        if (existingAttachment?.temporaryUrl) {
          return {
            original_name: existingAttachment.original_name,
            description: existingAttachment.description,
            content: existingAttachment.temporaryUrl,
            id: existingAttachment.id
          };
        }
        const base64Data = await convertFileToBase64(file);
        return {
          original_name: file.name,
          description: file.name,
          content: base64Data
        };
      }) ?? []
    );
    return attachmentsArray;
  };
  return (
    <>
      <div className="my-2 bg-white rounded p-3">
        <form>
          <div className="d-flex px-2 gap-3">
            <div className="col-4 px-2">
              <label className="fw-medium">Item Code *</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={1}
                  autoFocus={true}
                  type="text"
                  register={register}
                  name="code"
                  errors={errors.code}
                  className="form-control"
                  placeholder="Enter Code"
                  required={true}
                />
              </div>
            </div>
            <div className="col-4 px-2">
              <label className="fw-medium">Item Name *</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={2}
                  type="text"
                  register={register}
                  name="name"
                  errors={errors.name}
                  className="form-control"
                  placeholder="Enter Description"
                  required={true}
                />
              </div>
            </div>
          </div>
          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
              <label className="fw-medium">Item Description</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={3}
                  type="text"
                  register={register}
                  name="description"
                  errors={errors.description}
                  className="form-control"
                  placeholder="Field Content"
                />
              </div>
            </div>
            <div className="col-4 px-2">
              <label className="fw-medium">HTS Code</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={3}
                  type="text"
                  register={register}
                  name="hts_code"
                  errors={errors.hts_code}
                  className="form-control"
                  placeholder="Enter HTS Code"
                />
              </div>
            </div>
          </div>
          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
              <label className="fw-medium">Item Category</label>
              <div className="mt-1">
                <FormSelect
                  tabIndex={5}
                  name="item_category"
                  control={control}
                  optionList={formSelectOptionList(
                    props.lookupData.itemsCategories
                  )}
                  className="form-control p-0"
                  placeholder="Select"
                  isSearchable={true}
                />
              </div>
            </div>
            <div className="col-4 px-2">
              <label className="fw-medium">Item Group</label>
              <div className="mt-1">
                <FormSelect
                  tabIndex={6}
                  name="item_group"
                  control={control}
                  optionList={formSelectOptionList(props.lookupData.itemsGroup)}
                  className="form-control p-0"
                  placeholder="Select"
                  isSearchable={true}
                />
              </div>
            </div>
          </div>
          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
              <label className="fw-medium">Sale Price</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={9}
                  type="text"
                  register={register}
                  name="unit_price"
                  errors={errors.unit_price}
                  className="form-control"
                  placeholder="Enter $ Price"
                  // required={true}
                />
              </div>
            </div>
            <div className="col-4 px-2">
              <label className="fw-medium">Base Cost</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={10}
                  type="text"
                  register={register}
                  name="unit_cost"
                  errors={errors.unit_cost}
                  className="form-control"
                  placeholder="Enter $ Price"
                  // required={true}
                />
              </div>
            </div>
          </div>

          <div className="d-flex px-2 mt-3 gap-3">
            <div className="col-4 px-2">
              <label className="fw-medium">Average Cost</label>
              <div className="mt-1">
                <InputFiled
                  tabIndex={11}
                  type="text"
                  register={register}
                  name="average_unit_cost"
                  errors={errors.average_unit_cost}
                  className="form-control"
                  placeholder="Enter $ Price"
                />
              </div>
            </div>
            <div className="col-4 px-2">
              <label className="fw-medium">Upload Image</label>
              <div className="mt-1 mb-2">
                <DragAndDropButton
                  buttonName="Upload"
                  title="Import File"
                  buttonClassName="btn btn-color rounded-pill px-5"
                  dragAndDropModalMessage={`Drag and drop the file to import`}
                  acceptableFiles={["PNG", "JPG"]}
                  forCrop={true}
                  multiple={false}
                  data={setDataForLogo}
                />
                </div>
              {dataForLogo &&
                Object.values(dataForLogo)?.map((file, idx) => (
                  <div
                    key={idx}
                    className="mt-2 align-self-center text-truncate upload-msg-text fw-medium  clicked-option-with-background-and-cross"
                  >
                    {file.name}
                    <TiDelete onClick={() => handleDeleteFileForLogo(idx)} />
                  </div>
                ))}
                {(dataForLogo && Object.keys(dataForLogo)?.length===0 && getValues("logo")?.url) && (
                  <div className=" d-flex justify-content-start position-relative col-4 px-2 mt-2">
                    <a href={
                        getValues("logo") && getValues("logo").url
                          ? getValues("logo").url
                          : require("../../assets/images/noimage.png")
                      }
                      target="_blank"
                      >
                    <img
                      alt="Client Logo"
                      src={
                        getValues("logo") && getValues("logo").url
                          ? getValues("logo").url
                          : require("../../assets/images/noimage.png")
                      }
                      className="img-fluid rounded border"
                      style={{ maxWidth: "200px", maxHeight: "150px", objectFit: 'contain', height: "45px", width: "45px" }}

                    />
                    </a>
                  </div>
                )}
            </div>
          </div>
        </form>
      </div>

      <div className="my-2 bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={13}
            className="sph-btn me-4"
            handleClick={handleSubmit(nextData)}
          >
            Next
          </FormButton>
          <FormButton
            tabIndex={14}
            className="sph-btn sph-shift me-4"
            handleClick={handelCancelBtn}
          >
            Cancel
          </FormButton>
        </div>
      </div>
    </>
  );
}
